/**
 * MAX storefront settings API client (BFF: `/api/v1/store/settings/max`).
 */
import { apiClient } from '@/shared/api';
import type { MaxSettings, UpdateMaxSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/max';

export const getMaxSettings = async (): Promise<MaxSettings> => (await apiClient.get<MaxSettings>(BASE)).data;

export const updateMaxSettings = async (body: UpdateMaxSettingsRequest): Promise<MaxSettings> =>
  (await apiClient.put<MaxSettings>(BASE, body)).data;
